import { theme } from 'antd';

const { defaultAlgorithm, darkAlgorithm } = theme;

// Colores globales reutilizables
const COLORS = {
  darkBg: '#141414',
  lightBg: '#ffffff',
  darkText: '#ffffff',
  lightText: '#000000',
  primary: '#1890ff',
  darkBorder: '#555',
  lightBorder: '#d9d9d9',
};

const getThemeConfig = (darkTheme) => ({
  algorithm: darkTheme ? darkAlgorithm : defaultAlgorithm,
  token: {
    colorBgBase: darkTheme ? COLORS.darkBg : COLORS.lightBg,
    colorText: darkTheme ? COLORS.darkText : COLORS.lightText,
    colorPrimary: COLORS.primary,
    colorInputPlaceholder: darkTheme ? '#999999' : '#aaa',
    colorBorder: darkTheme ? COLORS.darkBorder : COLORS.lightBorder,
    colorBgContainer: darkTheme ? '#1f1f1f' : COLORS.lightBg,
    colorTextPlaceholder: darkTheme ? '#aaa' : '#999',
    colorTextSecondary: darkTheme ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.65)',
  },
  components: {
    Menu: {
        darkItemBg: 'transparent',
        darkItemHoverBg: 'rgba(255,255,255,0.45)',
        colorBgMenu: 'transparent',
        colorSubMenuBg: 'transparent',
        itemBg: 'transparent',
        itemHoverBg: darkTheme ? 'rgba(0, 0, 0, 0.1)' : '#FFE5B9', 
        itemHoverColor: darkTheme ? '#FFE5B9' : '#1677ff', 
    },
  },
});

export default getThemeConfig;